import styled from 'styled-components';
import { Link } from '@sketch/components';
import '../ResponsiveImage/index.js';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage.js';

const StyledResponsiveImage = styled(ResponsiveImage) `
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  margin-right: 12px;
  border-radius: ${({ theme }) => theme.radii.rounded};
  object-fit: cover;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.border.A};
`;
const TitleContainer = styled.div `
  display: flex;
  align-items: baseline;
  margin-bottom: 4px;
`;
const Title = styled.h1 `
  font-size: ${({ theme }) => theme.fontSizes.F};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  transition: color ${({ theme }) => theme.transitions.duration[1]};
  margin: 0;
`;
const Author = styled.p `
  margin: 0 0 0 4px;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`;
const Description = styled.p `
  margin: 0 0 4px 0;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;
const ReadMore = styled.span `
  text-decoration: none;
  color: currentColor;
  transition: color ${({ theme }) => theme.transitions.duration[1]};
`;
const StyledLink = styled(Link) `
  display: flex;

  font-size: ${({ theme }) => theme.fontSizes.E};

  /* Reset all link styles */
  text-decoration: none;
  transition: none;
  white-space: pre-wrap;
  color: currentColor;

  &:hover {
    ${Title} {
      color: ${({ theme }) => theme.colors.foreground.secondary.D};
    }

    ${ReadMore} {
      text-decoration: underline;

      &:hover {
        color: currentColor;
      }

      &:active {
        color: currentColor;
      }
    }
  }
`;

export { Author, Description, ReadMore, StyledLink, StyledResponsiveImage, Title, TitleContainer };
